'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ = require('lodash');
var OptWeekRuleOperatorService = function OptWeekRuleOperatorService(optWeekService) {
  var memoizedPrepareValues = _.memoize(prepareValues);
  function prepareValues(optWeekRules) {
    var result = [];
    var valueIndex;
    var previousOperator;
    _.forEach(optWeekRules, function (currentRule) {
      var preparedValues;
      var allValues = optWeekService.getOptWeekData('rom-summary');
      if (currentRule.operator !== '!=') {
        valueIndex = _.findIndex(allValues, {
          value: currentRule.leftOperand.value
        });
      }
      var secondValueIndex = currentRule.rightOperand ? _.findIndex(allValues, {
        value: currentRule.rightOperand.value
      }) : undefined;
      switch (currentRule.operator) {
        case '=':
          preparedValues = currentRule.leftOperand;
          break;
        case '!=':
          currentRule.leftOperand.forEach(function (currentValue) {
            var valueIndex = _.findIndex(allValues, {
              value: currentValue
            });
            allValues.splice(valueIndex, 1);
          });
          preparedValues = allValues;
          break;
        case '>':
          preparedValues = allValues.slice(0, valueIndex);
          break;
        case '>=':
          preparedValues = allValues.slice(0, valueIndex + 1);
          break;
        case '<':
          preparedValues = allValues.slice(valueIndex + 1, allValues.length);
          break;
        case '<=':
          preparedValues = allValues.slice(valueIndex, allValues.length);
          break;
        case 'Between':
          if (valueIndex < secondValueIndex) {
            preparedValues = allValues.slice(valueIndex, secondValueIndex + 1);
          } else {
            preparedValues = allValues.slice(secondValueIndex, valueIndex + 1);
          }
          break;
        case 'Not Between':
          if (valueIndex < secondValueIndex) {
            allValues.splice(valueIndex, secondValueIndex - valueIndex + 1);
          } else {
            allValues.splice(secondValueIndex, valueIndex - secondValueIndex + 1);
          }
          preparedValues = allValues;
          break;
        default:
          preparedValues = allValues;
      }
      allValues = _.map(allValues, 'value');
      preparedValues = (0, _typeof2["default"])(preparedValues[0]) === 'object' ? _.map(preparedValues, 'value') : preparedValues;
      if (previousOperator && isNegativeOperator(currentRule.operator) || isNegativeOperator(previousOperator)) {
        result = _.intersection(result, preparedValues);
      } else {
        result = result.concat(preparedValues);
      }
      previousOperator = currentRule.operator;
    });
    return _.uniq(result);
  }
  function isOptWeekRuleEmpty(rules) {
    var optWeekRules = _.filter(rules, {
      searchContext: 'rom-summary',
      criterion: 'Opt Week'
    });
    if (optWeekRules[0]) {
      var result = memoizedPrepareValues(optWeekRules);
      return _.isEmpty(result);
    }
    return false;
  }
  function isNegativeOperator(operator) {
    var negativeOperators = ['!=', 'Not Between'];
    return negativeOperators.indexOf(operator) !== -1;
  }
  function transformRule(rules) {
    var optWeekRules = _.remove(rules, {
      searchContext: 'rom-summary',
      criterion: 'Opt Week'
    });
    if (optWeekRules[0]) {
      optWeekRules[0].leftOperand = memoizedPrepareValues(optWeekRules);
      optWeekRules[0].leftOperand2 = memoizedPrepareValues(optWeekRules);
      optWeekRules[0].operator = '=';
      optWeekRules[0].rightOperand = '';
      rules.push(optWeekRules[0]);
    }
    return rules;
  }
  return {
    isOptWeekRuleEmpty: isOptWeekRuleEmpty,
    transformRule: transformRule
  };
};
OptWeekRuleOperatorService.$inject = ['OptWeekService'];
module.exports = OptWeekRuleOperatorService;